import { cn } from "../../../utils";
import { Skeleton } from "../../Skeleton";

export interface TableSkeletonLoadingProps {
  dataLength: number;
  wrapperClassName?: string;
  skeletonClassName?: string;
}

export const TableSkeletonLoading: React.FC<TableSkeletonLoadingProps> = ({
  dataLength,
  wrapperClassName,
  skeletonClassName,
}) => {
  return Array.from({ length: dataLength || 10 }).map((_, index) => (
    <div
      key={index}
      className={cn(
        "ui:border-divider ui:sm:border-t ui:sm:p-2",
        wrapperClassName,
      )}
    >
      <Skeleton
        className={cn("ui:h-10 ui:w-full ui:sm:h-5", skeletonClassName)}
      />
    </div>
  ));
};
